import { Dict } from './Types';

import utils = egr.wcf.utils;

/**
 * Small helper function as replacement for conditional assignment.
 * Note: every call causes an additional function call. However, it
 * most cases it improves the code readability.
 */
export function getValue<T>(data: T | undefined | null, fallback: T): T {
    return data != null ? data : fallback;
}

function getWritablePropertyNames(object: object): Array<string> {
    const props: Array<string> = [];

    do {
        const names: Array<string> = Object.getOwnPropertyNames(object);
        for (const name of names) {
            const descriptor: PropertyDescriptor | undefined = Object.getOwnPropertyDescriptor(object, name);

            if (descriptor == null || descriptor.writable !== true) {
                continue;
            }

            if (props.indexOf(name) === -1) {
                props.push(name);
            }
        }
    } while (object = Object.getPrototypeOf(object));

    return props;
}

// tslint:disable:ban-types
export function bindMethods<T extends object>(object: T): T {
    for (const key of getWritablePropertyNames(object)) {
        // tslint:disable-next-line:ban-types
        const value: Function | undefined = (object as Dict<Function>)[key];

        if (
            key !== 'constructor' &&
            typeof value === 'function' &&
            !(object as Dict<Function>)[key].name.startsWith('bound ')
        ) {
            (object as Dict<Function>)[key] = value.bind(object);
        }
    }

    return object;
}
// tslint:enable:ban-types

export function loadScript(url: string): Promise<void> {
    return new Promise((resolve: VoidFunction, reject: (error: Error) => void) => {
        const script: HTMLScriptElement = document.createElement('script');

        script.onload = resolve;
        script.onerror = (event: ErrorEvent): void => {
            reject(event.error);
        };
        script.src = url;
        script.type = 'text/javascript';

        document.head.appendChild(script);
    });
}

function getUUIDReplaceCallback(c: string): string {
    // tslint:disable:no-bitwise
    const r: number = Math.random() * 16 | 0;
    const v: number = c === 'x' ? r : (r & 0x3 | 0x8);
    // tslint:enable:no-bitwise
    return v.toString(16);
}

export function getUUID(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, getUUIDReplaceCallback);
}

export function isDataUri(value: string | undefined | null): boolean {
    if (utils.string.isNullOrEmpty(value)) {
        return false;
    }
    return /^\s*data:([a-z]+\/[a-z]+(;[a-z\-]+\=[a-z\-]+)?)?(;base64)?,[a-z0-9\!\$\&\'\,\(\)\*\+\,\;\=\-\.\_\~\:\@\/\?\%\s]*\s*$/i.test(value);
}

export const doNothing: VoidFunction = (): void => { /* do nothing */ };


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/submodules/utils/Helper.ts